var PhoneNumberVerification = (function ($, _, Backbone, PromiseUtil) {

    var PhoneNumberVerification = CheckoutApiModel.extend({

        initialize: function (attrs, opts) {
            this._order = opts.order;
            this._defer = (new $.Deferred()).reject();

            var verification = this._order.get('PhoneVerification');

            var phoneFormat = verification.Fields.PhoneNumberFormat || {};
            var codeFormat = verification.Fields.VerificationCodeFormat || {};
            this.Phone = new Decoration(phoneFormat);
            this.VerificationCode = new Decoration(codeFormat);

            this.listenTo(this._order, 'change', _.bind(this._onModelUpdate, this));
        },

        verify: function (method) {
            if (PromiseUtil.isPending(this._defer))
                return PromiseUtil.rejected();

            var forcedPhoneVerficiation = method && method.forcePhoneVerification;

            if (this._order.get('PhoneVerification').IsRequired && (forcedPhoneVerficiation || this._order.get('DeliveryOptions').isOurpaySelect())) {
                this._defer = new $.Deferred();

                if (!this.Phone.get('Value')) {
                    var addressPhone = this._order.get('Delivery').current().get('Phone');
                    this.Phone.set('Value', addressPhone);
                    //TBD: may be do not call if phone exists
                }

                var that = this;
                var verification = this.verifyPhoneNumber();
                verification.always(function () {
                    that.trigger('required');
                });

                return this._defer.promise();
            } else {
                return PromiseUtil.resolved();
            }
        },

        verifyPhoneNumber: function () {
            if (!this.Phone.isValid()) return PromiseUtil.rejected();

            var that = this;
            var phone = this.getPhoneNumber();

            return this._api.normalizePhoneAndSendCode(phone)
                      .done(function (resp) {
                          that.Phone.setValid(!resp.Value.ErrorMessage);
                          that.set('CodeErrorMessage', '');
                          that.set('PhoneErrorMessage', resp.Value.ErrorMessage);
                          that.set('CountryCode', resp.Value.CountryCode);
                          that.Phone.set('Value', resp.Value.Phone);
                      });
        },

        checkVerificationCode: function () {
            if (!this.Phone.isValid() || !this.VerificationCode.isValid()) return PromiseUtil.rejected();

            var that = this;
            var phone = this.getPhoneNumber();
            var code = this.VerificationCode.get('Value');
            var defer = new $.Deferred();

            this._api.verificationCodeConfirm(phone, code)
                      .done(function (resp) {
                          that.VerificationCode.setValid(!resp.Value.ErrorMessage);
                          that.set('CodeErrorMessage', resp.Value.ErrorMessage);
                          that.set('PhoneErrorMessage', '');

                          if (resp.Value.NotificationMessage) {
                              defer.reject({ NotificationMessage: resp.Value.NotificationMessage });
                              that.update_checkout();
                          } else if (resp.Value.ErrorMessage) {
							  defer.reject({ ErrorMessage: resp.Value.ErrorMessage });
                          } else {
                              that._defer.resolve();
                              defer.resolve();
                          }
                      }).fail(defer.reject);

            return defer.promise();
        },

        getPhoneNumber: function () {
            return this.getCountryCode() + this.Phone.get('Value');
        },

        getCountryCode: function () {
            return this.get('CountryCode') ? ('+' + this.get('CountryCode')) : '';
        },

        cancel: function () {
            this._defer.reject();
        },

        _onModelUpdate: function () {
            var verification = this._order.get('PhoneVerification');

            var phoneFormat = verification.Fields.PhoneNumberFormat || {};
            var codeFormat = verification.Fields.VerificationCodeFormat || {};
            this.Phone.set(phoneFormat);
            this.VerificationCode.set(codeFormat);
        }
    });

    return PhoneNumberVerification;
})($, _, Backbone, PromiseUtil);